import { UserActionsBigQueryEvents } from './userActions';

export const BigQueryEvents = {
    userActions: UserActionsBigQueryEvents,
};
